import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  input,
} from '@angular/core';
import { ChipModule } from 'primeng/chip';
import { TableActiveFilters } from '../resource-table/resource-table.component';

@Component({
  selector: 'kon-mass-action-filters-notice',
  standalone: true,
  imports: [CommonModule, ChipModule],
  template: `
    <p class="mb-3 text-danger-600 flex items-start gap-2" *ngIf="search">
      <span
        >Pri hromadných akciách nie je možné použiť fulltextové vyhľadávanie,
        vymažte prosím obsah vyhľadávacieho poľa</span
      >
    </p>
    <div class="mb-4">
      <p class="mb-1">Aktívne filtre:</p>
      <div
        class="flex flex-wrap gap-1"
        *ngIf="(activeFilters | keyvalue)?.length; else noFilters"
      >
        <p-chip
          *ngFor="let filter of activeFilters | keyvalue"
          [label]="filter.value.label + ' (' + filter.value.count + ')'"
        />
      </div>
      <ng-template #noFilters>
        <span class="text-sm text-gray-500">Žiadne</span>
      </ng-template>
    </div>
    <p class="mb-3 text-danger-600 flex items-start gap-2">
      @if((activeFilters | keyvalue)?.length;){

      <span
        >POZOR! Upraví všetkých <b>{{ totalCount() }}</b> práve vyfiltrovaných
        záznamov.</span
      >
      } @else {
      <span
        >Pri hromadnej akcii je potrebné zadať aspoň jeden filter, aby sa
        zabránilo neúmyselnej aktualizácii všetkých záznamov.</span
      >
      }
    </p>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MassActionFiltersNoticeComponent {
  @Input() activeFilters: TableActiveFilters = {};

  @Input() search?: string | null;

  totalCount = input<number>();
}
